// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--font-family-base:\"Nunito\",sans-serif;--font-size:13px;--font-size-header:28px;--hover-color:#337ab7;--brand-color:#337ab7;--border-color:#ddd;--notification-color:#ff5a5f;--max-content-width:1000px;--screen-xs-min:480px;--screen-sm-min:768px;--screen-md-min:992px;--screen-lg-min:1200px}._1E7oF:hover{cursor:pointer}._21Vgu{border:1px solid #ccc;border-top:none;border-radius:4px;margin:auto}._29-_D{margin:auto auto 40px;font-family:sans-serif;-ms-touch-action:none;touch-action:none}.QnFKi{cursor:pointer}", ""]);
// Exports
exports.locals = {
	"link": "_1E7oF",
	"table": "_21Vgu",
	"container": "_29-_D",
	"row": "QnFKi"
};
module.exports = exports;
